$("body").on("contextmenu", function (e) {
    return false;
});
$('body').bind('cut copy paste', function (e) {
    e.preventDefault();
});

$(document).ready(function () {
    /* Ready */

  document.getElementsByTagName("html")[0].style.visibility = "visible";
   
    $('.productcard_sliders').flexslider({
      directionNav: false,
      controlNav: false,
      animation: "fade",
      touch: true,
      controlNav: false,
      fadeFirstSlide: false,
      slideshowSpeed: 5000
  	});


    $(".fade_on_ready").fadeIn('low');
 

    setTimeout(function () {

      $(".fade_on_ready_timer").fadeIn('low');
      
          $('.productcard_sliders').flexslider({
            directionNav: false,
            controlNav: false,
            animation: "fade",
            touch: true,
            controlNav: false,
            fadeFirstSlide: false,
            slideshowSpeed: 5000
          });
      }, 2000);
    /* Ready*/
});


